import axios from 'axios';
import config from '../helpers/config';

export const connectWallet = async payload => {
  try {
    const res = await axios.post(
      `${config.web3BaseUrl}/api/v1/create-wallet `,
      payload,
      { headers: { Authorization: config.web3AuthKey } },
    );
    const data = res.data;
    return {
      data: data,
      error: null,
    };
  } catch (e) {
    return {
      data: null,
      error: e,
    };
  }
};

export const connectWalletV2ForClaim = async payload => {
  try {
    const res = await axios.post(
      `${config.web3BaseUrl}/api/v2/create-wallet `,
      payload,
      { headers: { Authorization: config.web3AuthKey } },
    );
    const data = res.data;
    return {
      data: data,
      error: null,
    };
  } catch (e) {
    return {
      data: null,
      error: e,
    };
  }
};

export const submitWalletCode = async payload => {
  try {
    const res = await axios.post(
      `${config.web3BaseUrl}/api/v1/verify-wallet `,
      payload,
      { headers: { Authorization: config.web3AuthKey } },
    );
    const data = res.data;
    return {
      data: data,
      error: null,
    };
  } catch (e) {
    return {
      data: null,
      error: e,
    };
  }
};

export const checkValidAddress = async payload => {
  try {
    const res = await axios.post(`${config.web3BaseUrl}/api/v1/auth`, payload);
    const data = res.data;
    return {
      data: data,
      error: null,
    };
  } catch (e) {
    return {
      data: null,
      error: e,
    };
  }
};
